(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stiga-category-nav"]) return;
  try {
    

(function () {
  'use strict';

  class StigaNav {
    constructor(nav) {
      this.nav      = nav;
      this.trigger  = nav.querySelector('.snav__trigger');
      this.mega     = nav.querySelector('.snav__mega');
      this.catLinks = Array.from(nav.querySelectorAll('[data-snav-cat-idx]'));
      this.catItems = Array.from(nav.querySelectorAll('[data-snav-cat]'));
      this.panels   = Array.from(nav.querySelectorAll('[data-snav-panel]'));

      this.mobBtn     = nav.querySelector('.snav__mob-btn');
      this.sheet      = nav.querySelector('.snav-sheet');
      this.sheetClose = nav.querySelector('.snav-sheet__close');
      this.overlay    = nav.querySelector('.snav-overlay');
      this.accBtns    = Array.from(nav.querySelectorAll('.snav-sheet__acc'));

      this._closeDelay = null;
      this._init();
    }

    _init() {
      /* Desktop: toggle mega on trigger click; open on hover */
      this.trigger?.addEventListener('click', () => this._toggleMega());
      this.trigger?.addEventListener('mouseenter', () => this._openMega());

      /* Keep mega open while mouse is inside */
      this.mega?.addEventListener('mouseenter', () => clearTimeout(this._closeDelay));
      this.mega?.addEventListener('mouseleave', () => {
        this._closeDelay = setTimeout(() => this._closeMega(), 150);
      });
      const bar = this.nav.querySelector('.snav__bar');
      bar?.addEventListener('mouseleave', () => {
        this._closeDelay = setTimeout(() => this._closeMega(), 150);
      });
      bar?.addEventListener('mouseenter', () => clearTimeout(this._closeDelay));

      /* Hover a category → switch panel */
      this.catLinks.forEach(link => {
        link.addEventListener('mouseenter', () => {
          const idx = parseInt(link.dataset.snavCatIdx, 10);
          this._switchPanel(idx);
        });
      });

      /* Close on outside click */
      document.addEventListener('click', e => {
        if (this.mega && !this.nav.contains(e.target)) this._closeMega();
      });

      /* Mobile */
      this.mobBtn?.addEventListener('click', () => this._openSheet());
      this.sheetClose?.addEventListener('click', () => this._closeSheet());
      this.overlay?.addEventListener('click', () => this._closeSheet());
      this.accBtns.forEach(btn => btn.addEventListener('click', () => this._toggleAcc(btn)));

      /* ESC */
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') { this._closeMega(); this._closeSheet(); }
      });

      this._switchPanel(0);
      this._activateCurrentPage();
    }

    _activateCurrentPage() {
      const handle = this.nav.dataset.activeHandle;
      if (!handle) return;
      let matched = -1;
      this.catItems.forEach((item, i) => {
        const handles = (item.dataset.handles || '').split(',');
        if (handles.includes(handle)) matched = i;
      });
      if (matched >= 0) this._switchPanel(matched);
    }

    _toggleMega() {
      const isOpen = this.mega?.getAttribute('aria-hidden') === 'false';
      isOpen ? this._closeMega() : this._openMega();
    }

    _openMega() {
      clearTimeout(this._closeDelay);
      this.mega?.setAttribute('aria-hidden', 'false');
      this.trigger?.setAttribute('aria-expanded', 'true');
    }

    _closeMega() {
      this.mega?.setAttribute('aria-hidden', 'true');
      this.trigger?.setAttribute('aria-expanded', 'false');
    }

    _switchPanel(idx) {
      this.panels.forEach((panel, i) => {
        const active = i === idx;
        panel.classList.toggle('snav__sub--active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        // Inline style guarantees visibility regardless of any theme CSS override
        panel.style.display = active ? 'flex' : 'none';
        if (active) {
          panel.style.flexDirection = 'column';
          panel.style.gap = '18px';
        }
      });
      this.catItems.forEach((item, i) => {
        item.classList.toggle('snav__cat--active', i === idx);
      });
    }

    _openSheet() {
      this.sheet?.setAttribute('aria-hidden', 'false');
      this.overlay?.setAttribute('aria-hidden', 'false');
      this.mobBtn?.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      this.sheetClose?.focus();
    }

    _closeSheet() {
      this.sheet?.setAttribute('aria-hidden', 'true');
      this.overlay?.setAttribute('aria-hidden', 'true');
      this.mobBtn?.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    _toggleAcc(btn) {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const sub = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!expanded));
      if (sub) sub.hidden = expanded;
    }
  }

  const boot = () => {
    const el = document.getElementById('snav');
    if (el) new StigaNav(el);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
}());


  } catch(e) { console.error(e); }
})();
})();
